import React from "react";
import { connect } from "react-redux";
import OwlCarousel from "react-owl-carousel";
import styled from "styled-components";

const DotContainer = styled.span`
  .owl-carousel {
    .owl-nav {
      .owl-prev,
      .owl-next {
        &.disabled {
          visibility: hidden;
        }
        width: 90px !important;
        border-radius: 4px !important;
        font-size: 14px;
        font-weight: 500;
        height: auto !important;
        text-align: center;
        display: inline-block;
        padding: 6px 8px;
        line-height: 1.4;
        background-color: ${props => props.bg};
        border: 2px solid ${props => props.bg};
        //  font: inherit;
        color: #fff;
        &:hover {
          background-color: transparent;
          cursor: pointer;
          color: ${props => props.bg};
        }
      }
    }
    .owl-dots {
      .owl-dot {
        border: 0;
        background: inherit;
        &.active {
          span,
          button {
            background: ${props => props.bg};
          }
        }
      }
    }
  }
`;

const Carousel = props => {
  const { baseColour, textPrev, textNext } = props;

  const options = {
    responsive: {
      0: {
        autoWidth: false,
        singleItem: true
      },

      480: {
        //autoWidth: true
        singleItem: false
      }
    },
    video: false,
    merge: true,
    loop: false,
    nav: true,
    navText: [textPrev, textNext],
    //navText: ["<div><button>" + textPrev + "</button></div>", "<div><button>" + textNext + "</button></div>"],
    items: 1,
    className: "invoice_slider owl-theme",
    responsiveBaseElement: DotContainer
  };

  return (
    <DotContainer bg={baseColour}>
      <OwlCarousel {...options}>{props.children}</OwlCarousel>
    </DotContainer>
  );
};

const mapStateToProps = state => {
  return {
    baseColour: state.app.domain.BaseColour
  };
};

export default connect(
  mapStateToProps,
  null
)(Carousel);
